
const accessorKeyHeaderRecord: Record<string, string> = {
    "commissionRate": "Commission Rate",
    "Consignor Group": "Consignor Group",
}

export default accessorKeyHeaderRecord;